import { Link } from "react-router-dom";
import { LOGO_WHITE } from "@/lib/api";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-navy-900 text-ivory border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img src={LOGO_WHITE} alt="Park Communications" className="h-12 w-auto mb-6" />
          <p className="text-ivory/55 max-w-sm leading-relaxed">
            A strategic communications and crisis management firm advising leaders through the moments that define them.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="overline text-gold mb-5">Navigate</p>
          <ul className="space-y-3 text-ivory/70">
            <li><Link to="/services" className="link-underline">Services</Link></li>
            <li><Link to="/faq" className="link-underline">FAQ</Link></li>
            <li><a href="/#about" className="link-underline">About</a></li>
            <li><a href="/#engagements" className="link-underline">Engagements</a></li>
            <li><a href="/#contact" className="link-underline">Contact</a></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="overline text-gold mb-5">Get in touch</p>
          <a href="mailto:info@parkcomms.com" className="block font-serif text-xl link-underline mb-4">info@parkcomms.com</a>
          <Link to="/admin" data-testid="footer-admin-link" className="overline text-ivory/40 hover:text-gold transition-colors">
            Client Portal
          </Link>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 py-6 flex flex-col sm:flex-row justify-between gap-2 text-ivory/40 text-xs">
          <span>&copy; {new Date().getFullYear()} Park Communications. All rights reserved.</span>
          <span>Strategic Communications &middot; Crisis Management &middot; Reputation Advisory</span>
        </div>
      </div>
    </footer>
  );
};
